import React, { Component, CSSProperties, useMemo } from "react"
import { choose } from "choose-matching"
import classNames from "classnames"

import { LoadingBlock } from "@src/app/components/LoadingBlock"
import { Navigation } from "@src/app/components/navigation"
import { NoContent } from "@src/app/components/NoContent/Index"
import { useDashboardLayout } from "@src/app/layouts/dashboardLayout"
import css from "./index.module.css"

export type DefaultPageLayoutProps = {
  backAction?: () => void
  button?: React.ReactElement
  children: React.ReactElement
  className?: string
  emptyBlock?: React.ReactElement
  hideBack?: boolean
  isEmpty?: boolean
  isLoading?: boolean
  title: string
  url?: string
}
export const DefaultPageLayout = ({
  children,
  className,
  emptyBlock = <NoContent title={"No content"} />,
  isEmpty = false,
  isLoading = false,
  ...navProps
}: DefaultPageLayoutProps) => {
  const { layout } = useDashboardLayout()
  const style = useMemo<
    CSSProperties & { "--dashboard-page-padding": string }
  >(() => {
    return {
      ...(isEmpty ? { backgroundColor: "white" } : {}),
      "--dashboard-page-padding": `${layout.pagePadding}px`,
    }
  }, [isEmpty, layout.pagePadding])

  return (
    <main className={classNames([css.wrap, className])} style={style}>
      <Navigation className={css.nav} {...navProps}></Navigation>

      <main className={css.content}>
        {choose(
          [isLoading, <LoadingBlock />],
          [
            !isLoading,
            choose(
              [isEmpty, emptyBlock],
              [!isEmpty, children],
            ) as React.ReactElement,
          ],
        )}
      </main>
    </main>
  )
}
